import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import Home from '../pages/Home'
import Login from '../pages/Login'
import Register from '../pages/Register'
import ThankYou from '../pages/ThankYou'
import Contact from "../pages/Contact"
import ProductDetails from "../pages/ProductDetails.jsx"
import TypeProduct from '../pages/TypeProduct'
import About from '../pages/About.jsx'
import BlogList from '../components/Blog/BlogList.jsx'
import AddBlog from '../pages/AddBlog.jsx'
import BlogDetail from '../components/Blog/BlogDetail.jsx'
import Admin from '../pages/Admin.jsx'
import AddProduct from '../pages/AddProduct'
import PrivacyPolicy from '../pages/Policies/PrivacyPolicy.jsx'
import ReturnPolicy from '../pages/Policies/ReturnPolicy.jsx'
import Support from '../pages/Policies/Support.jsx' 

function Routers() {
  return (
    <Routes>
        <Route path='/' element={<Navigate to='/trang-chu'/>}/>
        <Route path='/trang-chu' element={<Home/>} />
        <Route path='/admin/login' element={<Login/>} />
        <Route path='/register' element={<Register/>} />
        <Route path='/thank-you' element={<ThankYou/>} />
        <Route path='/lien-he' element={<Contact/>} />
        <Route path='/san-pham/:id' element={<TypeProduct/>} />
        <Route path='/san-pham/:id/:slug' element={<ProductDetails/>} />
        <Route path='/gioi-thieu' element={<About/>}/>
        <Route path='/blogs' element={<BlogList/>}/>
        <Route path='/admin/add-blog' element={<AddBlog/>}/>
        <Route path='/blog/:id' element={<BlogDetail/>}/>
        <Route path='/admin/dashboard' element={<Admin/>}/>
        <Route path="/admin/edit-blog/:id" element={<AddBlog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/admin/add-product" element={<AddProduct />} />
        <Route path="/admin/edit-product/:masp" element={<AddProduct />} />
        <Route path="/chinh-sach-doi-tra" element={<ReturnPolicy />} />
        <Route path="/chinh-sach-bao-mat" element={<PrivacyPolicy />} />
        <Route path="/ho-tro" element={<Support />} />
    </Routes>
  )
}

export default Routers